var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConvertSpeechintotext(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_372_2359)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.8125 1.98755V14.1875H62.0125L49.8125 1.98755Z",
    fill: "#002C3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.075 17.925V0.125H32V39.975H63.875V17.925H46.075ZM37.9875 6.225H41.9625V9.9625H37.9875V6.225ZM37.9875 14.2H41.9625V17.9375H37.9875V14.2ZM57.8875 33.8625H37.9875V30.125H57.9V33.8625H57.8875ZM57.8875 25.9H37.9875V22.1625H57.9V25.9H57.8875Z",
    fill: "#002C3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.475 12.025H19.3375L17.7 10.375L20.3375 7.73755L26.5 13.9L20.3375 20.0625L17.7 17.425L19.35 15.775H14.4875C12.4125 15.775 10.725 17.4625 10.725 19.5375V27.0625H6.98755V19.5375C6.98755 15.3875 10.35 12.025 14.475 12.025Z",
    fill: "#47ADB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3501 58.6625C38.4251 58.6625 40.1126 56.975 40.1126 54.9V50.525L38.4626 52.175L35.8251 49.5375L41.9876 43.375L48.1501 49.5375L45.5126 52.175L43.8626 50.525V54.9C43.8626 59.0375 40.5001 62.4 36.3626 62.4H32.6001V58.6625H36.3501Z",
    fill: "#47ADB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.625 43.2375C22.625 48.4125 18.4125 52.625 13.2375 52.625C8.0625 52.625 3.85 48.4125 3.85 43.2375V41.3625H0.125V43.2375C0.125 49.0875 3.9625 54.05 9.2625 55.7375V63.875H17.2375V55.7375C22.525 54.05 26.375 49.0875 26.375 43.2375V41.3625H22.625V43.2375Z",
    fill: "#002C3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8625 43.2375V39.4875C18.8625 36.3875 16.3375 33.875 13.25 33.875C10.1625 33.875 7.625 36.3875 7.625 39.4875V43.2375C7.625 46.3375 10.15 48.85 13.2375 48.85C16.325 48.85 18.8625 46.3375 18.8625 43.2375Z",
    fill: "#002C3E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_372_2359"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConvertSpeechintotext);
export default __webpack_public_path__ + "static/media/ConvertSpeechintotext.8ce595fde61aa95b716cfee1b3dbbf69.svg";
export { ForwardRef as ReactComponent };